import React from 'react';
import { MapPin, Compass, ExternalLink } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { DistanceFilter } from './DistanceFilter';

export default function RestaurantsTab({ filteredRestaurants, restaurantFilter, setRestaurantFilter }) {
  return (
    <div data-testid="restaurants-tab">
      <div className="mb-6">
        <h2 className="font-['Playfair_Display'] text-2xl font-bold text-zinc-900 mb-2">Où manger ?</h2>
        <p className="text-zinc-600 mb-4">Bonnes tables autour de Sanxay</p>
        <DistanceFilter value={restaurantFilter} onChange={setRestaurantFilter} testId="restaurant-filter" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {filteredRestaurants.map((r, index) => (
          <Card key={index} className="border-0 shadow-lg" data-testid={`restaurant-${index}`}>
            <CardContent className="p-6">
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h3 className="font-bold text-zinc-900">{r.name}</h3>
                  <p className="text-sm text-lime-600">{r.type}</p>
                </div>
                <Badge variant="outline" className="text-xs">{r.distanceLabel}</Badge>
              </div>
              <p className="text-sm text-zinc-600 mb-2">{r.description}</p>
              {r.address && <p className="text-xs text-zinc-500 mb-1 flex items-center gap-1"><MapPin className="h-3 w-3" /> {r.address}</p>}
              {r.phone && <a href={`tel:${r.phone.replace(/\s/g, '')}`} className="text-xs text-zinc-500 hover:text-lime-600 mb-2 flex items-center gap-1">Tel: {r.phone}</a>}
              <span className="text-fuchsia-600 font-medium">{r.price}</span>
            </CardContent>
          </Card>
        ))}
      </div>
      {filteredRestaurants.length === 0 && (
        <div className="text-center py-8 text-zinc-500">Aucun restaurant trouvé pour ce rayon. Essayez un filtre plus large.</div>
      )}
    </div>
  );
}
